export const TRAIL_PREPEND_LABEL = 'AP'
export const PRIVILEGED_TRAIL_PREPEND_LABEL = 'PA'

/**
 * TrailHashId is in format alpha.agent-1:2  => [prefix].[agentId]:[trailid]
 * Return agentNumber:trailId only
 */
function parseTrailIdHashToFriendlyLabel (trailLabel) {
  let trailLabelArr = trailLabel.split(':')
  let trailId = trailLabelArr[1]
  let agentInfo = ''
  if (trailLabelArr[0].includes('-')) {
    agentInfo = trailLabelArr[0].split('-')[1]
  } else {
    agentInfo = trailLabelArr[0]
  }

  return `${agentInfo}:${trailId}`
}

export function getUserFriendlyTrailLabel (trailLabel) {
  trailLabel = String(trailLabel)
  if (trailLabel.includes(':')) {
    return parseTrailIdHashToFriendlyLabel(trailLabel)
  }
  return `${TRAIL_PREPEND_LABEL}-${trailLabel}`
}

export function getUserFriendlyPrivilegedTrailLabel (trailLabel) {
  trailLabel = String(trailLabel)
  if (trailLabel.includes(':')) {
    return parseTrailIdHashToFriendlyLabel(trailLabel)
  }
  return `${PRIVILEGED_TRAIL_PREPEND_LABEL}-${trailLabel}`
}



// WEBPACK FOOTER //
// ./src/utilities/trail.helper.js